var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dialog"},[_c('div',{staticClass:"card"},[_c('h1',[_vm._v("Add Device")]),_vm._v(" "),_c('DeviceForm',{on:{"hide-dialog":function($event){return _vm.$emit('hide-device-form')},"save-device":_vm.saveDevice}})],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-532ba27d","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/device/NewDevice.vue
// module id = null
// module chunks = 